import script from "./UiKitMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiKitMain.vue?vue&type=script&setup=true&lang=ts"

import "./UiKitMain.vue?vue&type=style&index=0&id=5e2ed03a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e2ed03a"]])

export default __exports__